import type {Spring, Transition} from "framer-motion";

export const homematchTinderSpringTransition: Spring = {
    type: "spring",
    stiffness: 300,
    damping: 30
};

export const HOMEMATCH_TINDER_MOTION_EASE = [0.4, 0, 0.2, 1] as const;

export const HOMEMATCH_TINDER_REDUCED_MOTION_DURATION = 0.18;

export const HOMEMATCH_TINDER_TWEEN_DURATION = 0.4;

export const homematchTinderReducedMotionTransition: Transition = {
    duration: HOMEMATCH_TINDER_REDUCED_MOTION_DURATION
};

export const homematchTinderTweenTransition: Transition = {
    duration: HOMEMATCH_TINDER_TWEEN_DURATION,
    ease: [...HOMEMATCH_TINDER_MOTION_EASE]
};

interface IDeckHeightMotionTransitionParams {
    isAdvancing: boolean;
    shouldReduceMotion: boolean;
}

export const getHomematchTinderDeckHeightMotionTransition = (params: IDeckHeightMotionTransitionParams): Transition => {
    const {isAdvancing, shouldReduceMotion} = params;

    if (isAdvancing) return {duration: 0};

    if (shouldReduceMotion) return homematchTinderReducedMotionTransition;

    return homematchTinderTweenTransition;
};
import type {Spring, Transition} from "framer-motion";

export const homematchTinderSpringTransition: Spring = {
    type: "spring",
    stiffness: 300,
    damping: 30
};

export const HOMEMATCH_TINDER_MOTION_EASE = [0.4, 0, 0.2, 1] as const;

export const HOMEMATCH_TINDER_REDUCED_MOTION_DURATION = 0.18;

export const HOMEMATCH_TINDER_TWEEN_DURATION = 0.4;

export const homematchTinderReducedMotionTransition: Transition = {
    duration: HOMEMATCH_TINDER_REDUCED_MOTION_DURATION
};

export const homematchTinderTweenTransition: Transition = {
    duration: HOMEMATCH_TINDER_TWEEN_DURATION,
    ease: [...HOMEMATCH_TINDER_MOTION_EASE]
};

interface IDeckHeightMotionTransitionParams {
    isAdvancing: boolean;
    shouldReduceMotion: boolean;
}

export const getHomematchTinderDeckHeightMotionTransition = (params: IDeckHeightMotionTransitionParams): Transition => {
    const {isAdvancing, shouldReduceMotion} = params;

    if (isAdvancing) return {duration: 0};

    if (shouldReduceMotion) return homematchTinderReducedMotionTransition;

    return homematchTinderTweenTransition;
};
